"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Snack = _interopRequireDefault(require("./Snack"));
var _types = require("./types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class AnimatedSnack extends _react.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      shouldRender: true,
      isFadeOut: false
    };
    this.hideSnack = ({
      notification,
      conflictMsg,
      callback
    }) => {
      this.setState({
        isFadeOut: true
      });
      if (this.fadeOutTimer) {
        clearTimeout(this.fadeOutTimer);
      }
      this.hideTimeout = setTimeout(() => {
        this.setState({
          shouldRender: false
        });
        if (this.props.onHide) {
          this.props.onHide({
            notification,
            conflictMsg,
            callback
          });
        }
      }, 1000);
    };
    this.handleMouseEnter = () => {
      if (this.fadeOutTimer) clearTimeout(this.fadeOutTimer);
    };
    this.handleMouseLeave = () => {
      this.delay = null;
    };
  }
  componentDidMount() {
    this.delay = null;
  }
  componentWillUnmount() {
    clearTimeout(this.fadeOutTimer);
    clearTimeout(this.hideTimeout);
  }
  set delay(delay) {
    if (this.delay) {
      this.fadeOutTimer = setTimeout(() => {
        this.hideSnack({
          notification: this.props.notification
        });
      }, this.delay);
    }
  }
  get delay() {
    if (this.props.notification.delay !== (null || undefined)) {
      return this.props.notification.delay;
    }
    if (this.props.delay !== (null || undefined)) {
      return this.props.delay;
    }
    return 3000;
  }
  render() {
    return this.state.shouldRender && _react.default.createElement(_Snack.default, {
      localeData: this.props.localeData,
      notification: {
        ...this.props.notification,
        createdOn: null,
        isRead: null
      },
      isFadeOut: this.state.isFadeOut,
      onMouseEnter: () => this.handleMouseEnter(),
      onMouseLeave: () => this.handleMouseLeave(),
      onHide: this.hideSnack,
      handleNotification: this.props.handleNotification
    });
  }
}
var _default = exports.default = AnimatedSnack;